module.exports = __webpack_public_path__ + "static/media/9DESA3.c8a70d5d.jpg";